import React, { useState } from 'react';
import { SizeGuideProps } from 'src/components/SizeGuide/SizeGuide';
import { Button } from 'src/components/Button/Button';
import { LazyLoader } from 'src/components/Helpers/LazyLoader';
import { Svg } from 'src/components/Svg/Svg';

import classes from './SizeGuideLoader.scss';

const LazySizeGuide: React.FC<SizeGuideProps> = React.lazy(
    () => import(/* webpackChunkName:"__lazy__size-guide" */ './SizeGuide'),
);

export const SizeGuideLoader: React.FC<{ sizeGuide: string; isBundle?: boolean }> = (props) => {
    const { sizeGuide, isBundle } = props;
    const [guideOpen, toggleGuide] = useState(false);

    const openGuideClickHandler = () => toggleGuide(true);
    const closeGuideClickHandler = () => toggleGuide(false);

    return (
        <>
            <Button onClick={openGuideClickHandler} className={classes.sizesGuide} variant="reset">
                <Svg name="sizing" />
                Sizing
            </Button>
            {sizeGuide && guideOpen && (
                <LazyLoader
                    fallback={null}
                    loader={<LazySizeGuide isBundle={isBundle} sizeGuide={sizeGuide} close={closeGuideClickHandler} />}
                />
            )}
        </>
    );
};
